import { memo } from 'react'

import { StarIconState } from '../ui/Stars/StarIconState'

interface StarRatingProps {
  rating: number
  maxStars: number
  width?: number
  height?: number
  className?: string
  color?: string
}

const StarRating = memo(
  ({
    rating,
    maxStars,
    width = 11,
    height = 13,
    className = '',
    color = '#FFCD4E',
  }: StarRatingProps) => {
    const stars = []
    const fullStars = Math.floor(rating)
    const partialStar = rating % 1

    for (let i = 0; i < fullStars; i++) {
      stars.push(
        <StarIconState
          key={i}
          value={1}
          width={width}
          height={height}
          className={className}
          color={color}
        />
      )
    }

    if (partialStar > 0) {
      stars.push(
        <StarIconState
          key="partial"
          value={partialStar}
          width={width}
          height={height}
          className={className}
          color={color}
        />
      )
    }

    while (stars.length < maxStars) {
      stars.push(
        <StarIconState
          key={`empty-${stars.length}`}
          value={0}
          width={width}
          height={height}
          className={className}
          color={color}
        />
      )
    }

    return <div className="flex gap-xxxs">{stars}</div>
  }
)

StarRating.displayName = 'StarRating'

export default memo(StarRating)
